/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Shadow_Opacity_AriaInputs */

const en_video_export_shadow_opacity_aria = /** @type {(inputs: Video_Export_Shadow_Opacity_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shadow Opacity`)
};

const fr_video_export_shadow_opacity_aria = /** @type {(inputs: Video_Export_Shadow_Opacity_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opacite de l'ombre`)
};

const de_video_export_shadow_opacity_aria = /** @type {(inputs: Video_Export_Shadow_Opacity_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schattendeckkraft`)
};

const it_video_export_shadow_opacity_aria = /** @type {(inputs: Video_Export_Shadow_Opacity_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opacità dell'ombra`)
};

const ru_video_export_shadow_opacity_aria = /** @type {(inputs: Video_Export_Shadow_Opacity_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Прозрачность тени`)
};

const es_video_export_shadow_opacity_aria = /** @type {(inputs: Video_Export_Shadow_Opacity_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opacidad de la sombra`)
};

const zh_cn2_video_export_shadow_opacity_aria = /** @type {(inputs: Video_Export_Shadow_Opacity_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`阴影不透明度`)
};

const ja_video_export_shadow_opacity_aria = /** @type {(inputs: Video_Export_Shadow_Opacity_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`影の不透明度`)
};

const hi_video_export_shadow_opacity_aria = /** @type {(inputs: Video_Export_Shadow_Opacity_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`छाया अपारदर्शिता`)
};

const pt_pt2_video_export_shadow_opacity_aria = /** @type {(inputs: Video_Export_Shadow_Opacity_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opacidade da sombra`)
};

/**
* | output |
* | --- |
* | "Shadow Opacity" |
*
* @param {Video_Export_Shadow_Opacity_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_shadow_opacity_aria = /** @type {((inputs?: Video_Export_Shadow_Opacity_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Shadow_Opacity_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_export_shadow_opacity_aria(inputs)
	if (locale === "de") return de_video_export_shadow_opacity_aria(inputs)
	if (locale === "it") return it_video_export_shadow_opacity_aria(inputs)
	if (locale === "ru") return ru_video_export_shadow_opacity_aria(inputs)
	if (locale === "es") return es_video_export_shadow_opacity_aria(inputs)
	if (locale === "zh-CN") return zh_cn2_video_export_shadow_opacity_aria(inputs)
	if (locale === "ja") return ja_video_export_shadow_opacity_aria(inputs)
	if (locale === "hi") return hi_video_export_shadow_opacity_aria(inputs)
	if (locale === "pt-PT") return pt_pt2_video_export_shadow_opacity_aria(inputs)
	return en_video_export_shadow_opacity_aria(inputs)
});